import { render, staticRenderFns } from "./ButtonUpload.vue?vue&type=template&id=6fe1e09c&scoped=true&lang=pug"
import script from "./ButtonUpload.vue?vue&type=script&lang=ts"
export * from "./ButtonUpload.vue?vue&type=script&lang=ts"
import style0 from "./ButtonUpload.vue?vue&type=style&index=0&id=6fe1e09c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1e09c",
  null
  
)

export default component.exports